/**
 * @description reinitialize klarna On-Site Messaging widget
 */
export function refreshKlarnaOSM() {
    window.KlarnaOnsiteService = window.KlarnaOnsiteService || [];
    window.KlarnaOnsiteService.push({eventName: 'refresh-placements'});
}